import React from 'react';
import { Hits, Highlight } from 'react-instantsearch-hooks-web';
import HitLinkHandler from '../HitLinkHandler/HitLinkHandler';
import { useState } from 'react';

const SearchHits = ({ dataIndex, onHitDetails }) => {
  const summaryHTMLRemover = (hit) => {
    if (hit.summary === undefined) {
      return null;
    }
    const cleanText = hit.summary.replace(/<\/?[^>]+(>|$)/g, '');
    return cleanText;
  };

  const imageCompress = (hit) => {
    let imageLink = hit.image;
    if (hit.image === undefined) {
      imageLink = hit.thumbnail;
    }
    const removeRegex = imageLink.replace('https://s3.amazonaws.com/developertool/', 'https://travprocdn.imgix.net/');
    const imgixLink = removeRegex + '?auto=compress';
    return imgixLink;
  };

  const [active, setActive] = useState({});

  const handleMouseEnter = (hit) => {
    onHitDetails({
      backgroundColor: 'red',
      id: hit.id,
      title: hit.title,
      summary: summaryHTMLRemover(hit),
      description: hit.description,
      image: imageCompress(hit),
    });
    setActive(hit.id);
  };

  const Hit = ({ hit }) => {
    return (
      <HitLinkHandler id={hit.id} essentails_chapter={hit.essentials_chapter} typeHit="chapter">
        <article
          id="hitChapterArticle"
          style={hit.id === active ? { backgroundColor: 'red', opacity: 0.8 } : { backgroundColor: 'white' }}
          onMouseEnter={() => handleMouseEnter(hit)}
        >
          <div className="hitTextCon">
            <p className="hitTitle">
              {/* highlight should be styled */}
              <Highlight attribute="title" hit={hit} />
            </p>
            {summaryHTMLRemover(hit) ? <p className="hitSummaryText"> {summaryHTMLRemover(hit)}</p> : null}
            {hit.type ? <p className="hitSummaryText"> {hit.type}</p> : null}
          </div>
        </article>
      </HitLinkHandler>
    );
  };

  return (
    <div>
      {/* this should be mapped */}
      {dataIndex == 'chapters' && <Hits hitComponent={Hit} />}
      {dataIndex == 'pages' && <Hits hitComponent={Hit} />}
      {dataIndex == 'sales_companion_items' && <Hits hitComponent={Hit} />}
      {dataIndex == 'links' && <Hits hitComponent={Hit} />}
    </div>
  );
};
export default SearchHits;
